import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Button, Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, Stack, useTheme, useMediaQuery } from '@mui/material';
// component
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

EnvelopeListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  showSearch: PropTypes.bool,
  onExactSearch: PropTypes.func,
  onClearSearch: PropTypes.func,
  hasExactSearch: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
};

export default function EnvelopeListToolbar({
  numSelected,
  filterName,
  onFilterName,
  showSearch = true,
  onExactSearch,
  onClearSearch,
  hasExactSearch,
  searchPlaceholder = 'UUID do envelope',
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onExactSearch?.();
    }
  };

  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
        flexDirection: { xs: 'column', sm: 'row' },
        height: { xs: 'auto', sm: 96 },
        py: { xs: 2, sm: 0 },
        gap: { xs: 2, sm: 0 }
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selecionado{numSelected > 1 ? 's' : ''}
        </Typography>
      ) : showSearch ? (
        <Stack direction={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'stretch' : 'center'} spacing={1} flexWrap="wrap" useFlexGap>
          <StyledSearch
            value={filterName || ''}
            onChange={onFilterName}
            onKeyDown={handleKeyDown}
            placeholder={searchPlaceholder}
            startAdornment={
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
              </InputAdornment>
            }
            sx={{
              width: { xs: '100%', sm: 240 },
              '&.Mui-focused': {
                width: { xs: '100%', sm: 320 },
              }
            }}
          />
          {onExactSearch && (
            <Button
              variant="contained"
              size="small"
              onClick={onExactSearch}
              startIcon={<Iconify icon="eva:search-fill" />}
            >
              Buscar
            </Button>
          )}
          {onClearSearch && (filterName || hasExactSearch) && (
            <Button variant="outlined" size="small" onClick={onClearSearch}>
              Limpar
            </Button>
          )}
        </Stack>
      ) : null}

      {numSelected > 0 ? (
        <Tooltip title="Deletar">
          <IconButton>
            <Iconify icon="eva:trash-2-fill" />
          </IconButton>
        </Tooltip>
      ) : onExactSearch ? null : (
        <Tooltip title="Filtrar lista">
          <IconButton>
            <Iconify icon="ic:round-filter-list" />
          </IconButton>
        </Tooltip>
      )}
    </StyledRoot>
  );
}
